import {keycloakConfig} from "./config";
import Keycloak from "keycloak-js";

export const keycloak = new Keycloak(keycloakConfig);